import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import header from '@/components/header.vue'
import software from '@/components/software.vue'
import tutorialDown from '@/components/tutorialDown.vue'
import troubleshooting from '@/components/troubleshooting.vue'
import searching from '@/components/searching.vue'
import moreTutorial from '@/components/moreTutorial.vue'
import moreTroubleshooting from '@/components/moreTroubleshooting.vue'
import troubleshootingInfo from '@/components/troubleshootingInfo.vue'
import tutorialDownInfo from '@/components/tutorialDownInfo.vue'

Vue.use(Router)

export default new Router({
  // mode:'history',
  routes: [
    {
      path: '/header',
      name: 'header',
      component: header

    },
    {
      path: '/',
      name: 'software',
      component: software,
      meta:{
        title:'软件下载'
      }
    },
    {
      path: '/tutorialDown',
      name: 'tutorialDown',
      component: tutorialDown,
      meta:{
        title:'使用教程',
        keepAlive:true
      }
    },
    {
      path: '/troubleshooting',
      name: 'troubleshooting',
      component: troubleshooting,
      meta:{
        title:'故障排查',
        keepAlive:true
      }
    },
    {
      path: '/searching',
      name: 'searching',
      component: searching,
      meta:{
        title:'全局搜索',
        keepAlive:true
      }
    },
    {
      path: '/moreTutorial',
      name: 'moreTutorial',
      component: moreTutorial,
      meta:{
        title:'更多使用教程'
      }
    }
    ,
    {
      path: '/moreTroubleshooting',
      name: 'moreTroubleshooting',
      component: moreTroubleshooting,
      meta:{
        title:'更多故障排查'
      }
    },
    {
      path: '/troubleshootingInfo',
      name: 'troubleshootingInfo',
      component: troubleshootingInfo,
      meta:{
        title:'故障排查详情'
      }
    },{
      path: '/tutorialDownInfo',
      name: 'tutorialDownInfo',
      component: tutorialDownInfo,
      meta:{
        title:'使用教程详情'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js